import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=55fc8213&scoped=true"
var script = {}
import style0 from "./Update.vue?vue&type=style&index=0&id=55fc8213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc8213",
  null
  
)

export default component.exports